import React from 'react';

import useMediaQuery from 'hooks/use-media-query';

import { RedemptionButton } from './redemption-button';
import { RestaurantRedemptionButtonUiOption } from './types';

type IRestaurantRedemptionButton = {
  onClickRestaurantRedemption: () => void;
  restaurantRedemptionButtonUiType: RestaurantRedemptionButtonUiOption;
  restaurantRedemptionButtonTitle: string;
  disabled?: boolean;
  isLoading?: boolean;
};

export const RestaurantRedemptionButton: React.FC<IRestaurantRedemptionButton> = ({
  onClickRestaurantRedemption,
  restaurantRedemptionButtonTitle,
  restaurantRedemptionButtonUiType,
  disabled,
  isLoading,
}) => {
  const isDesktop = useMediaQuery('desktop');

  return (
    <>
      <RedemptionButton
        onClickRestaurantRedemption={onClickRestaurantRedemption}
        restaurantRedemptionButtonTitle={restaurantRedemptionButtonTitle}
        restaurantRedemptionButtonUiType={restaurantRedemptionButtonUiType}
        disabled={disabled}
        isDesktop={isDesktop}
        isLoading={isLoading}
      />
    </>
  );
};
